import type { CurrencyBalance } from '../types/finance';

/**
 * PORTAL-01: `PortfolioSummary.balances` is kept SEPARATE per currency —
 * the backend never sums `investments.ledger_entries` across `currency_code`
 * into one blended scalar (a client holding products in more than one
 * currency gets one row per currency). Today's dashboard/agent surfaces
 * display a single "primary" currency (derived from the client's upcoming
 * maturities, defaulting to MXN) — this picks that one row rather than
 * re-blending the list. A client legitimately holding balances in more
 * than one currency needs a dedicated multi-currency dashboard layout;
 * that is a product/design decision, not something to infer here.
 *
 * Returns a zeroed row (in `currencyCode`) when the client has no balance
 * in that currency yet, so callers never have to null-check.
 */
export function pickCurrencyBalance(
  balances: readonly CurrencyBalance[],
  currencyCode: string,
): CurrencyBalance {
  const match = balances.find((b) => b.currency_code === currencyCode);
  return match ?? { currency_code: currencyCode, total_balance: '0', accumulated_yield: '0' };
}
